<template lang="pug">
  div.PointCost
    van-dropdown-menu(class="select_box")
      van-dropdown-item(v-model="active", :options="status")
    van-collapse(v-model="record",accordion)
      van-list(v-model="listLoading", @load="onListLoad", :loading-text="$t('loading')", :finished-text="$t('noMore')", error-text="...", :finished="finished")
        div(class="hst_box van-clearfix", v-for='(item, key) in orderList', v-if="item.status > -1", :key="key")
          van-collapse-item(class="pointCost_list")
            template(#icon)
              img(class="pointCost_icon", :src="item.appIcon || defaultIcon")
            template(#title)
              p.title {{formatInte(item)}}
              p.time {{formatDate(item.createTime, true)}}
            template(#value)
              p.status {{origin(item.originId)}}
</template>

<script>
// @ is an alias to /src
// import HelloWorld from '@/components/HelloWorld.vue'
import {mapActions, mapGetters} from 'vuex';
import Qs from 'qs';

export default {
  name: 'PointCost',
  data($vm){
    return{
      active: '',
      record: -1,
      defaultIcon: require('@/assets/head_icon.png'),
      orderList:[],
      pageNumber: 1,
      listLoading: false,
      finished: false,
      loadStatus: true,
      statusActive: ''
    }
  },
  created(){
    this.getIncomeDetail({
      uid: this.uid,
      deviceId: this.deviceId,
      accessToken: this.token,
      pageNumber: 1,
      language: this.lang
    })
  },
  methods:{
    ...mapActions('record', ['getIncomeDetail']),
    onListLoad(){
      if(this.loadStatus){
        return false
      }
      this.loadStatus = true
      this.pageNumber += 1
      this.getIncomeDetail({
        uid: this.uid,
        deviceId: this.deviceId,
        accessToken: this.token,
        pageNumber: this.pageNumber,
        status: this.statusActive,
        language: this.lang
      })
    }
  },
  computed:{
    ...mapGetters(['uid', 'deviceId', 'token']),
    ...mapGetters('record', ['loadingID', 'incomeDetail']),
    origin: $vm => {
      return val => {
        if(val === "1"){
          return $vm.$t('fromBuy')
        } else 
        if(val === "2"){
          return $vm.$t('fromPay')
        } else 
        if(val === "3"){
          return $vm.$t('fromCost')
        } else 
        if(val === "4"){
          return $vm.$t('fromBind')
        }
      }
    },
    status: $vm => {
      return [
        {
          text: $vm.$t('all'),
          value: ''
        },
        {
          text: $vm.$t('income'),
          value: '1'
        },
        {
          text: $vm.$t('cost'),
          value: '0'
        }
      ]
    },
    formatDate: (val, key = false) => {
      return (val, key= false) => {
        let payDate = new Date(parseInt(val));
        if(key){
          return payDate.getFullYear() + '-' + (payDate.getMonth() + 1) + '-' + payDate.getDate() + '  ' + payDate.getHours() + ':' + payDate.getMinutes() + ':' + payDate.getSeconds() + '    ' + 'UTC+' + (0 - new Date().getTimezoneOffset() / 60);
        } else {
          return payDate.getFullYear() + '-' + (payDate.getMonth() + 1) + '-' + payDate.getDate() + '  ' + payDate.getHours() + ':' + payDate.getMinutes() + ':' + payDate.getSeconds()
        }
      }
    },
    formatInte: val => {
      return val => {
        if(val.status === '1'){
          return '+' + val.integral
        } else {
          return '-' + val.integral
        }
      }
    }
  },
  mounted(){
    this.$watch('loadingID', val => {
      if(val === 'loadedID'){
        this.incomeDetail.list.map(val => {
          this.orderList.push(val)
        })
        if(this.orderList.length == this.incomeDetail.total){
          this.finished = true
        }
        this.loadStatus = false
        this.listLoading = false
      }
    })
    this.$watch('active', val => {
      this.pageNumber = 1
      this.loadStatus = true
      this.finished = false
      this.orderList = []
      this.statusActive = val 
      this.getIncomeDetail({
        uid: this.uid,
        deviceId: this.deviceId,
        accessToken: this.token,
        pageNumber: 1,
        status: val
      })
    })
  }
}
</script>
<style lang="scss">
.PointCost{
  margin: 20px;
  .van-dropdown-menu__item{
    margin: 0 4px;
  }
  .van-dropdown-menu__title::after{
    right: 0px;
  }
  .select_box{
    width: 50%;
    position: relative;
    left: 50%;
    .van-dropdown-menu__bar{
      height: 30px;
    }
  }
  .pointCost_list{
    margin-top: 10px;
    .van-cell__value{
      position: absolute;
      right: 20px;
      line-height: 45px;
      p{
        margin: 0;
      }
    }
    .van-cell__right-icon{
      width: 0;
      min-width: 0;
      line-height: 60px;
      &::before{
        content: '';
      }
    }
    .van-collapse-item__content{
      p{
        margin: 0;
        padding: 5px 10px;
      }
    }
  }
  .pointCost_icon{
    height: 60px;
    width: 60px;
    position: relative;
  }
  .title{
    margin: 0;
    font-size: 18px;
    color: #000;
    padding-left: 10px;
    font-weight: bolder;
  }
  .time{
    margin: 0;
    font-size: 12px;
    color: #969799;
    padding-left: 10px;
    margin-top: 12px;
  }
  .van-hairline--top-bottom::after{
    border-width: 0px;
  }
  .hst_box{
      position: relative;
  }
}
</style>